import { render, staticRenderFns } from "./rmAkpr.vue?vue&type=template&id=7f6697a0"
import script from "./rmAkpr.vue?vue&type=script&lang=js"
export * from "./rmAkpr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports